import { Alcohol } from '../models/Alcohol';

export const AlcoholTranslateMap: Record<keyof Alcohol, string> = {
    id: 'Default',
    name: 'Product name',
    alcohol: 'Alcohol volume',
    energy_value_kj: 'Energy value (kJ)',
    energy_value_kcal: 'Energy value (kCal)',
    fat: 'Fats',
    carbohydrates: 'Carbohydrates',
    protein: 'Proteins',
    salt: 'Salt',
    brand: 'Brand',
    alcohol_free: '',
    alcohol_equal: '',
    alcohol_less_than: '',
    enabled: '',
    image_id: '',
    image_url: '',
    ingredients: '',
    note: '',
    protein_less_than: '',
    protein_equal: '',
    saturated_fatty_acids: 'Saturated_fatty_acids_sort_label',
    sugars: 'Sugars_sort_label',
    sugars_less_than: '',
    sugars_equal: ''
};
